import { UserLoginModel } from '@nstep-common/core';
import { ExtraValidator } from '@nstep-common/utils';

export class LoginCardModelValidator extends ExtraValidator<UserLoginModel> {
	constructor() {
		super();

		this.ruleFor('userName')
			.must(userName => !!userName)
			.withMessage('The AMIS Card Number field is required')
			.matches(new RegExp('^([A-Za-z]{3})(-[0-9]{7})(-[0-9]{2})$'))
			.withMessage('You must specify a valid AMIS Card Number');

		this.ruleFor('password')
			.matches(/^\d{4,6}$/)
			.withMessage('You must specify a valid PIN');
	}
}

export class LoginModelValidator extends ExtraValidator<UserLoginModel> {
	constructor() {
		super();

		this.ruleFor('userName')
			.must(userName => !!userName)
			.withMessage('The User name field is required');

		this.ruleFor('password')
			.must(password => !!password)
			.withMessage('The Password field is required');
	}
}